import './Footer.css';

function Footer() {
  const year = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer" id="footer">
      <div className="footer-container">
        <div className="footer-brand">
          <h3>
            <span className="footer-accent">&lt;</span>DM
            <span className="footer-accent">/&gt;</span>
          </h3>
          <p>Cybersecurity Student & Full Stack Developer.</p>
        </div>

        <div className="footer-links">
          <a href="#Home">Home</a>
          <a href="#About">About</a>
          <a href="#Skills">Skills</a>
          <a href="#Projects">Projects</a>
          <a href="#contact">Contact</a>
        </div>

        <div className="footer-social">
          <a
            href="https://www.linkedin.com/in/dehili-mohammed-0664092b4/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <i className="fab fa-linkedin-in"></i>
          </a>
          <a
            href="https://github.com/Dehili-Mohammed"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
          >
            <i className="fab fa-github"></i>
          </a>
          <a
            href="https://www.instagram.com/dm._.mohe_med/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <i className="fab fa-instagram"></i>
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-copy">
          © {year} Dehili Mohammed. All rights reserved.
        </p>
        <button
          className="back-to-top"
          onClick={scrollToTop}
          aria-label="Back to top"
        >
          <i className="fas fa-arrow-up"></i>
        </button>
      </div>
    </footer>
  );
}

export default Footer;
